import "./style.scss";
import { Link } from "react-router-dom";
import { headerNavLinks } from "@/src/constants/header";
import HeaderDeskSubMenuSlider from "./HeaderDeskSubMenuSlider/HeaderDeskSubMenuSlider";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
import { Dispatch, FC, SVGProps } from "react";

interface HeaderSubMenuProps {
  isHovering: boolean;
  setIsHovering: Dispatch<React.SetStateAction<boolean>>;
  activeSubmenu: IHeaderActiveSubMenu[];
  activeMenuId: string | null | undefined;
  handleMouseEnterZone: () => void;
  handleMouseLeaveZone: () => void;
}
interface IHeaderActiveSubMenu {
  id: string;
  text: string;
  description: string;
  image?: FC<SVGProps<SVGSVGElement>>;
  link: string;
}

const HeaderSubMenu = ({
  isHovering,
  setIsHovering,
  activeSubmenu,
  activeMenuId,
  handleMouseEnterZone,
  handleMouseLeaveZone,
}: HeaderSubMenuProps) => {
  const handleLinkEvent = () => {
    setIsHovering(false);
    document.body.classList.remove("body-blur-overlay");
  };
  return (
    <div className={`sub-menu ${isHovering && activeSubmenu.length > 0 ? "visible" : ""}`}>
      <div
        className="sub-menu-content"
        onMouseEnter={handleMouseEnterZone}
        onMouseLeave={handleMouseLeaveZone}
      >
        <div className="container">
          <div className="sub-menu-content-body">
            <p className="sub-menu-content-body-title">
              {headerNavLinks.find((item) => item.id === activeMenuId)?.text}
            </p>
            <div className="sub-menu-content-body-grid">
              {activeSubmenu.map((sub) => (
                <Link
                  to={sub.link}
                  key={sub.id}
                  className="sub-menu-content-body-grid-card"
                  onClick={() => handleLinkEvent()}
                >
                  <div className="sub-menu-content-body-grid-card-svg">
                    {sub.image && <sub.image />}
                  </div>
                  <div>
                    <p className="card-title">{sub.text}</p>
                    <p className="card-description">{sub.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="sub-menu-content-news">
            <div className="sub-menu-content-news-body">
              <p className="sub-menu-content-news-title">МЫ ПРЕДЛАГАЕМ</p>
              <HeaderDeskSubMenuSlider handleLinkEvent={handleLinkEvent} />
              <ReadMoreBtn
                text="Подробнее →"
                link="#"
                className="sub-menu-content-news-read-more-btn"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="sub-menu-blur"></div>
    </div>
  );
};

export default HeaderSubMenu;
